import EstimateField from "./estimate";

export default class EstimateFieldMinutes extends EstimateField {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.ESTIMATE_MINUTES;
        this.formulaCompatible = false;
    }

    getCsvValue(item) {
        let res = item.estimate;
        if (res) res = gd.utils.Time.roundMinutes(res);
        return res;
    }
}